"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGtmService = void 0;
var _dayjs = _interopRequireDefault(require("dayjs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var push = function push(obj) {
  var _window$dataLayer, _window;
  var dataLayer = (_window$dataLayer = (_window = window) === null || _window === void 0 ? void 0 : _window.dataLayer) !== null && _window$dataLayer !== void 0 ? _window$dataLayer : [];
  dataLayer.push(obj);
};
var _pushBroker = function pushBroker(broker) {
  if (broker) return push({
    broker: broker
  });
  return null;
};
var _pushStepContinueButtonClick = function pushStepContinueButtonClick(step) {
  if (step) {
    return push({
      event: 'step_continue_btn_click',
      attributes: {
        step_name_click: step
      }
    });
  }
  return null;
};
var _pushUserId = function pushUserId(quote) {
  if (quote && quote.appId) {
    return push({
      userId: quote.appId
    });
  }
  return null;
};
var _pushGA3UserTimingTracking = function pushGA3UserTimingTracking(_ref) {
  var timingValue = _ref.timingValue,
    timingCategory = _ref.timingCategory,
    timingVariable = _ref.timingVariable,
    timingLabel = _ref.timingLabel;
  return push({
    event: 'ngTrackTiming',
    attributes: {
      timingValue: timingValue,
      timingCategory: timingCategory,
      timingVariable: timingVariable,
      timingLabel: timingLabel
    }
  });
};
var _pushGA3EventTracking = function pushGA3EventTracking(_ref2) {
  var eventValue = _ref2.eventValue,
    eventCategory = _ref2.eventCategory,
    eventAction = _ref2.eventAction,
    eventLabel = _ref2.eventLabel;
  return push({
    event: 'ngTrackEvent',
    attributes: {
      eventValue: eventValue,
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      eventNonInteraction: true
    }
  });
};
var _pushGA3PageView = function pushGA3PageView(currentPath, pageTitle) {
  return push({
    event: 'ngStateChange',
    attributes: {
      state: currentPath,
      pageTitle: pageTitle
    }
  });
};
var _pushAdFixusGA3PageView = function pushAdFixusGA3PageView(state, pageTitle) {
  var _window2;
  var afxAcid = '';
  var afxProfileId = '';
  var afxPridPart1 = '';
  var afxPridPart2 = '';
  var afxPridPart3 = '';
  var afxIdentity = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.AfxIdentity;
  if (afxIdentity !== null && afxIdentity !== void 0 && afxIdentity.getProfile) {
    var _afxProfileId;
    var profile = afxIdentity.getProfile();
    afxAcid = (profile === null || profile === void 0 ? void 0 : profile.acid) || '';
    afxProfileId = (profile === null || profile === void 0 ? void 0 : profile.prid) || '';
    if (((_afxProfileId = afxProfileId) === null || _afxProfileId === void 0 ? void 0 : _afxProfileId.length) === 216) {
      afxPridPart1 = afxProfileId.slice(0, 72);
      afxPridPart2 = afxProfileId.slice(72, 144);
      afxPridPart3 = afxProfileId.slice(144);
    }
  }
  return push({
    event: 'ngStateChange',
    attributes: {
      state: state,
      pageTitle: pageTitle,
      afx_acid: afxAcid,
      afx_profileId: afxProfileId,
      afx_prid_part1: afxPridPart1,
      afx_prid_part2: afxPridPart2,
      afx_prid_part3: afxPridPart3
    }
  });
};
var _pushGA4PageView = function pushGA4PageView(_ref3) {
  var partnerName = _ref3.partnerName,
    partnerCode = _ref3.partnerCode,
    partnerCategory = _ref3.partnerCategory,
    stepName = _ref3.stepName,
    stepNumber = _ref3.stepNumber;
  return push({
    event: 'page_view',
    attributes: {
      partner_name: partnerName,
      partner_code: partnerCode,
      partner_category: partnerCategory,
      step_name: stepName,
      step_number: stepNumber
    }
  });
};
var _pushGA4Quote = function pushGA4Quote(eventName, quote) {
  return push({
    event: eventName,
    attributes: {
      coupon: quote.promotionCode,
      owner_age: (0, _dayjs["default"])().year() - (0, _dayjs["default"])(quote.owner.dateofBirth).year(),
      owner_postcode: quote.owner.postcode,
      owner_state: quote.owner.state,
      payment_frequency: quote.paymentFrequency,
      pets: quote.pets.map(function (pet) {
        var _pet$selectedQuote, _pet$selectedQuote2, _pet$selectedQuote3;
        return {
          cover_plan: (_pet$selectedQuote = pet.selectedQuote) === null || _pet$selectedQuote === void 0 ? void 0 : _pet$selectedQuote.planNumber,
          cover_excess: (_pet$selectedQuote2 = pet.selectedQuote) === null || _pet$selectedQuote2 === void 0 ? void 0 : _pet$selectedQuote2.excess,
          cover_routine_care: null,
          cover_dental_care: null,
          cover_benefit_limit: (_pet$selectedQuote3 = pet.selectedQuote) === null || _pet$selectedQuote3 === void 0 ? void 0 : _pet$selectedQuote3.annualBenefitLimit,
          pet_age: (0, _dayjs["default"])().year() - (0, _dayjs["default"])(pet.petDOB).year(),
          pet_breed: pet.breed,
          pet_maturity: null,
          pet_name: pet.petName,
          pet_species: pet.species
        };
      })
    }
  });
};
var _pushGA4ViewItemList = function pushGA4ViewItemList(quote) {
  return push({
    event: 'view_item_list',
    attributes: {
      items: quote.pets.map(function (pet) {
        return {
          pet_name: pet.petName,
          pet_products: pet.petProducts
        };
      })
    }
  });
};
var pushGA4FormInteraction = function pushGA4FormInteraction(quote) {
  return push({
    event: 'form_field_track',
    attributes: {
      form_name: null,
      field_name: null,
      field_value: null
    }
  });
};
var _pushGA4EnquiryCall = function pushGA4EnquiryCall(event) {
  var _event$target;
  return push({
    event: 'enquiry_call',
    attributes: {
      phoneNumber: event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.innerHTML
    }
  });
};
var _pushGA4EnquiryMail = function pushGA4EnquiryMail() {
  return push({
    event: 'enquiry_mail',
    attributes: {}
  });
};
var _pushGA4RequestCallback = function pushGA4RequestCallback() {
  return push({
    event: 'request_callback',
    attributes: {}
  });
};
var _pushGA4eCommerce = function pushGA4eCommerce(quote) {
  if (quote !== undefined && quote !== null) {
    if (quote.applicationSubmitted !== undefined && quote.applicationSubmitted !== null && quote.applicationSubmitted === true && quote.onlineNumber !== undefined && quote.onlineNumber !== null && quote.onlineNumber > 0 && quote.quoteReferenceNumber !== undefined && quote.quoteReferenceNumber !== null && quote.quoteReferenceNumber !== '' && quote.pets !== undefined && quote.pets.length > 0) {
      var _quote$owner;
      var items = [];
      var pets = [];
      var coupon = quote !== null && quote !== void 0 && quote.hasPromotionCode && quote !== null && quote !== void 0 && quote.promotionCode ? quote.promotionCode : '';
      var customerEmail = (quote === null || quote === void 0 || (_quote$owner = quote.owner) === null || _quote$owner === void 0 ? void 0 : _quote$owner.email) || '';
      quote.pets.forEach(function (pet) {
        if (pet.petName !== undefined && pet.petName !== null && pet.petName !== '' && pet.petDOB !== undefined && pet.petDOB !== null && pet.petDOB !== '') {
          var currentDate = new Date();
          var petBirthDate = new Date(pet.petDOB);
          var petAge = currentDate.getFullYear() - petBirthDate.getFullYear();
          var monthDiff = currentDate.getMonth() - petBirthDate.getMonth();
          var adjustedAge = monthDiff < 0 || monthDiff === 0 && currentDate.getDate() < petBirthDate.getDate() ? petAge - 1 : petAge;
          if (adjustedAge !== undefined && adjustedAge !== null && adjustedAge >= 0) {
            if (pet.selectedQuote !== undefined && pet.selectedQuote !== null) {
              var petItem = {
                age: adjustedAge,
                name: pet.petName,
                breed: pet.breed,
                species: pet.species,
                selectedProduct: pet.selectedQuote.productName,
                premium: pet.selectedQuote.totalPremiumAmount
              };
              pets.push(petItem);
            }
          }
        }
        if (pet) {
          if (pet.selectedQuote) {
            var item = {
              item_name: pet.selectedQuote.productName,
              item_id: pet.selectedQuote.planNumber,
              price: pet.selectedQuote.totalPremiumAmount,
              item_brand: quote.selectedPartner.partnerName,
              item_category: pet.selectedQuote.productCode,
              item_category2: pet.selectedQuote.excess,
              item_variant: pet.selectedQuote.productName,
              affiliation: quote.selectedPartner.broker,
              quantity: 1
            };
            items.push(item);
          }
        }
      });
      push({
        ecommerce: null
      });
      push({
        event: 'petsure-purchase',
        ecommerce: {
          transaction_id: quote.quoteReferenceNumber,
          affiliation: quote.selectedPartner.partnerName,
          value: quote.totalPremium,
          currency: 'AUD',
          items: items,
          coupon: coupon,
          pets: pets,
          paymentFrequency: quote.paymentFrequency,
          customerEmail: customerEmail
        }
      });
    }
  }
};
var getGtmService = exports.getGtmService = function getGtmService() {
  return {
    /**
         *
         * @param { string } broker
         */
    pushBroker: function pushBroker(broker) {
      return _pushBroker(broker);
    },
    /**
         *
         * @param { string } step
         */
    pushStepContinueButtonClick: function pushStepContinueButtonClick(step) {
      return _pushStepContinueButtonClick(step);
    },
    /**
         *
         * @param { Object } quote
         */
    pushUserId: function pushUserId(quote) {
      return _pushUserId(quote);
    },
    /**
         * @param { Object } data
         * @param { Object } timingTrackingData
         */
    pushGA3UserTimingTracking: function pushGA3UserTimingTracking() {
      var timingTrackingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        timingValue: null,
        timingCategory: null,
        timingVariable: null,
        timingLabel: null
      };
      return _pushGA3UserTimingTracking(timingTrackingData);
    },
    /**
         *
         * @param { Object } data
         * @param { Object } eventTrackingData
         */
    pushGA3EventTracking: function pushGA3EventTracking() {
      var eventTrackingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        eventValue: null,
        eventCategory: null,
        eventAction: null,
        eventLabel: null
      };
      return _pushGA3EventTracking(eventTrackingData);
    },
    /**
         *
         * @param { string } currentPath
         * @param { string } pageTitle
         */
    pushGA3PageView: function pushGA3PageView(currentPath, pageTitle) {
      return _pushGA3PageView(currentPath, pageTitle);
    },
    /**
         *
         * @param { string } currentPath
         * @param { string } pageTitle
         */
    pushAdFixusGA3PageView: function pushAdFixusGA3PageView(currentPath, pageTitle) {
      return _pushAdFixusGA3PageView(currentPath, pageTitle);
    },
    /**
         *
         * @param { Object } pageViewData
         */
    pushGA4PageView: function pushGA4PageView() {
      var pageViewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        partnerName: null,
        partnerCode: null,
        partnerCategory: null,
        stepName: null,
        stepNumber: null
      };
      return _pushGA4PageView(pageViewData);
    },
    /**
         *
         * @param { string } eventName
         * @param { Object } quote
         */
    pushGA4Quote: function pushGA4Quote(eventName, quote) {
      return _pushGA4Quote(eventName, quote);
    },
    /**
         *
         * @param { Object } quote
         */
    pushGA4ViewItemList: function pushGA4ViewItemList(quote) {
      return _pushGA4ViewItemList(quote);
    },
    /**
         *
         * @param { Object } event
         */
    pushGA4EnquiryCall: function pushGA4EnquiryCall(event) {
      return _pushGA4EnquiryCall(event);
    },
    pushGA4EnquiryMail: function pushGA4EnquiryMail() {
      return _pushGA4EnquiryMail();
    },
    pushGA4RequestCallback: function pushGA4RequestCallback() {
      return _pushGA4RequestCallback();
    },
    pushGA4eCommerce: function pushGA4eCommerce(quote) {
      return _pushGA4eCommerce(quote);
    }
  };
};